// extracted by mini-css-extract-plugin
export default {"heroContentMobile":"qX1GB0Eu9QZmoFcOvfEd","sublead":"rKEL_9Sn71cO0QvGyMnx"};